import httpHelper from "@/helpers/httpHelper";

const vipService = {
    async get() {
        return await httpHelper.get("/WebApi/Vip/Get");
    }
};

export default vipService;